import React from "react";
import { Eye, EyeOff } from "lucide-react";
import { Button } from "../../../../components/button";
import { useTranslation } from "react-i18next";
import { ButtonIcon } from "../../../../components/button";

interface SurveyActionButtonsProps {
  onPreview: () => void;
  onSaveDraft: () => Promise<void>;
  isLoading?: boolean;
  loadingState?: "draft" | "publish" | null;
  disabled?: boolean;
  isPreviewMode?: boolean; // Track if preview mode is active
}

export const SurveyActionButtons: React.FC<SurveyActionButtonsProps> = ({
  onPreview,
  onSaveDraft,
  isLoading = false,
  loadingState = null,
  disabled = false,
  isPreviewMode = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-3 justify-end">
      {/* Eye Icon - Toggle Preview/Edit Mode */}
      <ButtonIcon
        onClick={onPreview}
        title={isPreviewMode ? "Back to edit" : "Preview survey"}
        aria-label={
          isPreviewMode ? t("surveys.buttons.edit_mode") : t("surveys.buttons.preview_aria_label")
        }
        disabled={isLoading || disabled}
      >
        {isPreviewMode ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
      </ButtonIcon>

      {/* Save Draft - Secondary */}
      <Button
        onClick={onSaveDraft}
        disabled={isLoading || disabled}
        type="button"
        variant="outline"
        className="
                    h-10 px-6
                    bg-white dark:bg-gray-800
                    border border-gray-300 dark:border-gray-600
                    text-gray-700 dark:text-gray-300
                    hover:bg-gray-50 dark:hover:bg-gray-700
                    disabled:opacity-50 disabled:cursor-not-allowed
                    transition-colors
                "
      >
        {loadingState === "draft" ? (
          <>
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-700 dark:border-gray-300 mr-2"></div>
            {t("common.saving")}...
          </>
        ) : (
          t("surveys.buttons.save_draft")
        )}
      </Button>
    </div>
  );
};
